import { render } from "./veiculosAvaliacao.vue?vue&type=template&id=35c8a00e&scoped=true"
import script from "./veiculosAvaliacao.vue?vue&type=script&lang=js"
export * from "./veiculosAvaliacao.vue?vue&type=script&lang=js"

import "./veiculosAvaliacao.vue?vue&type=style&index=0&id=35c8a00e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c8a00e"]])

export default __exports__